import { PrintRequest, PrintResult, PrintTransport } from './printing.types';

export type QzPrintDelegate = (request: PrintRequest) => void | Promise<void>;

export class QzPrintTransport implements PrintTransport {
  constructor(private readonly delegate: QzPrintDelegate) {}

  async isAvailable(): Promise<boolean> {
    return true;
  }

  async print(request: PrintRequest): Promise<PrintResult> {
    await this.delegate(request);
    return { transport: 'qz', copies: 1 };
  }
}
